import { LingAttribute } from './ling-attribute';
import { LingFileEntity } from './ling-file-entity';
import {
  Certificate,
  CertificateDynamicSection,
  CertificateGeneralSection,
  CertificateKeyMetric,
  HeaderSettings,
} from './certificate';

export class CertificateCreateRequest {
  issuer?: string;
  name?: string;
  description?: string;
  images?: LingFileEntity[] = [];
  attributes: LingAttribute<any>[] = [];
  edition?: string;
  tagId?: string;
  dynamicSections?: CertificateDynamicSection[];
  general?: CertificateGeneralSection;
  headerSettings?: HeaderSettings;
  keyMetrics?: CertificateKeyMetric[];
  certificateOfAuthenticityView?: boolean;

  constructor(
    certificateRequestSource?: CertificateCreateRequest | Certificate
  ) {
    if (certificateRequestSource) {
      if (certificateRequestSource instanceof Certificate) {
        this.issuer = certificateRequestSource.issuer?.name;
        this.name = certificateRequestSource.name;
        this.description = certificateRequestSource.description;
        this.images = certificateRequestSource.general?.images;
        this.attributes = certificateRequestSource.attributes ?? [];
        this.edition = certificateRequestSource.edition?._id;
        this.dynamicSections = certificateRequestSource.dynamicSections;
        this.general = certificateRequestSource.general;
        this.headerSettings = certificateRequestSource.headerSettings;
        this.keyMetrics = certificateRequestSource.keyMetrics;
        this.certificateOfAuthenticityView =
          certificateRequestSource.certificateOfAuthenticityView;
      } else {
        Object.assign(this, certificateRequestSource);
      }
    }
  }
}
